module.exports = "<span [ngClass]=\"setStatusStyle()\" (click)=\"onClick()\">{{ notificationConfigStatus | addSpaceBetweenWords }}</span>\n"